<template>
  <v-dialog 
    v-model="isOpen"
    width="600"
    max-width="600"
    persistent
  >
    <v-card class="pa-0">
      <v-card-title>
        Ad Approval Notice
      </v-card-title>
      <v-card-text>
        There is an ad approval process that checks ad content against creative policies and requirements, which takes place 
        during business hours only and can take up to 3 hours to complete. Once approved, your ads will be live. Your 
        estimated approval time is {{estimatedApprovalDateTime()}}.
      </v-card-text>
      <v-card-actions class="justify-center">
          <v-btn
            dark
            color="blue darken-2"
            @click="acknowledgeApproval"
            >OK</v-btn
          >
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script>
export default {
  name: 'AdApprovalMessaging',
  props: {
    dialogIsOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpen() {
      return this.dialogIsOpen
    },
  },
  methods: {
    estimatedApprovalDateTime() {
      // returns the time in this format: December 17, 2023 1:00 PM (browser local time).
      // The basis ad approval office hours are Monday to Friday 10am to 6pm EST,
      // so if the current time is within those hours, add 3 hours to the current time,
      // but if the current time is outside those hours (or is less than 3 hours from the
      // office closing time), add 3 hours to the next day's 10am
      const localTime = new Date()
      // Convert the current time to the office's local time (EST)
      const currentEST = new Date(localTime.toLocaleString("en-US", { timeZone: "America/New_York" }))
      const currentESTDay = currentEST.getDay() // Sunday is 0, Monday is 1, ..., Saturday is 6
      const currentLocalTimeDay = localTime.getDay() // Sunday is 0, Monday is 1, ..., Saturday is 6
      // get the hour difference between the current time and the office's local time
      const hourDifference = localTime.getHours() - currentEST.getHours()
      // Set the office hours in EST (Eastern Standard Time)
      const estOfficeStartHour = 10
      const estOfficeEndHour = 15 // 6pm minus 3 hours
      const localStartHour = estOfficeStartHour + hourDifference
      const isWithinOfficeHours = 
        currentEST.getHours() >= estOfficeStartHour && currentEST.getHours() <= estOfficeEndHour && // Between 10am and 3pm
        currentESTDay >= 1 && currentESTDay <= 5 // Monday to Friday
      // Check if the current time is within office hours
      if (isWithinOfficeHours) {
        // If within office hours, add 3 hours to the current time
        localTime.setHours(localTime.getHours() + 3)
      } else {
        // If outside office hours or less than 3 hours from closing time, move to the next day's 10am + 3 hours
        const nextDay = currentESTDay >= 5 ? 1 : currentLocalTimeDay + 1 // If Fri-Sun (EST), go to Monday, else just go to local time's next day
        const daysUntilNextDay = nextDay - currentLocalTimeDay + (nextDay <= currentLocalTimeDay ? 7 : 0) // Handle wrapping around to the next week
        localTime.setDate(localTime.getDate() + daysUntilNextDay)
        localTime.setHours(localStartHour + 3)
        localTime.setMinutes(0)
      }
      // Format the date to the desired string format
      const formattedTime = localTime.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      return formattedTime 
    },
    acknowledgeApproval() {
      this.$emit('approvalAcknowledged')
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
